import styled from 'styled-components';

export const FormModalContainer = styled.div`
    width: 569px;
    max-height: 500px;
    padding: 20px;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;
    overflow: auto;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const TabContainer = styled.div`
    min-width: 50%;
    max-width: 90%;
    margin: 10px;
    display: flex;
    justify-content: center;
`;

export const TabItem = styled.div`
    flex-basis: 100%;
    height: 30px;
    margin: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(239, 240, 242, 0.18);
    text-decoration: none;
    font-size: 12px;
    color: #fff;
    cursor: pointer;
    transition: all 0.5s;

    ${props => {
        if (props.first)
            return `
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        `;

        if (props.last)
            return `
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        `;
    }};

    &.active {
        background-color: #555556;
    }

    &:hover {
        background-color: #555556;
    }
`;

export const ScrollableWorkoutsContainer = styled.div`
    width: 100%;
    max-height: 100%;
    overflow: auto;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddWorkoutChallengeModal/style.js